import { Routes } from '@angular/router';
import { FlexFieldConfigManagerComponent } from './flex-field-config-manager/flex-field-config-manager.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

export const flexFieldRoutes: Routes = [
    {
        path: 'flex-fields/config',
        component: FlexFieldConfigManagerComponent,
        canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
        data: { enterpriseModules: ['WORKFLOW_AUTOMATION'], enterpriseFeatureLabel: 'Workflow Automation', permission: app_permissions.flex_fields.manage }
    }
];
